var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("SelectorDialog", { attrs: { viewModel: _vm.selectorDialog } }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.totalCostLimitEditorDialog },
        on: { "update-value": _vm.handleSetPortfolioTotalCostLimitCommand },
      }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.opexLimitEditorDialog },
        on: { "update-value": _vm.handleSetPortfolioOpexLimitCommand },
      }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.othexLimitEditorDialog },
        on: { "update-value": _vm.handleSetPortfolioOthexLimitCommand },
      }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.capexLimitEditorDialog },
        on: { "update-value": _vm.handleSetPortfolioCapexLimitCommand },
      }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.expensesLimitEditorDialog },
        on: { "update-value": _vm.handleSetPortfolioExpensesLimitCommand },
      }),
      _vm._v(" "),
      _c("NumericInputDialog", {
        attrs: { viewModel: _vm.opexExpensesLimitEditorDialog },
        on: { "update-value": _vm.handleSetPortfolioOpexExpensesLimitCommand },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "dashboard" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "20px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Enterprise Plan: " + _vm._s(_vm.rm.ScenarioName)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v("Portfolios")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-lg-6 d-flex flex-column justify-content-end",
                  },
                  [_c("ScenarioNavigation")],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _c("thead", { staticClass: "table-secondary" }, [
                      _c("tr", [
                        _c(
                          "th",
                          {
                            staticClass: "align-middle",
                            attrs: { colspan: "2" },
                          },
                          [_vm._v("Portfolio")]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Requested projects"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Selected projects"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Value points"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Revenue "),
                          _c("br"),
                          _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          {
                            staticClass: "align-middle text-center",
                            attrs: { title: _vm.rm.TotalCostLabel },
                          },
                          [
                            _vm._v("Cost "),
                            _c("br"),
                            _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                          ]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Cost of value point"),
                          _c("br"),
                          _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.rm.Portfolios, function (p) {
                        return _c("tr", { key: p.PortfolioId }, [
                          _c(
                            "td",
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(p.PortfolioName)
                              ),
                              _c("br"),
                              _vm._v(" "),
                              p.ScenarioId
                                ? [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value: `/#/portfolio-plan/projects/${p.WorkspaceId}/${p.TchProjectId}/${p.ScenarioId}`,
                                            expression:
                                              "`/#/portfolio-plan/projects/${p.WorkspaceId}/${p.TchProjectId}/${p.ScenarioId}`",
                                          },
                                        ],
                                        staticClass: "text-primary",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(p.ScenarioName) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              !p.ScenarioId
                                ? [
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value: `/#/portfolio-plans/${p.WorkspaceId}/${p.TchProjectId}`,
                                            expression:
                                              "`/#/portfolio-plans/${p.WorkspaceId}/${p.TchProjectId}`",
                                          },
                                        ],
                                        staticClass: "text-danger",
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    No portfolio plan\n                                "
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticClass: "text-center align-middle",
                              staticStyle: { width: "120px" },
                            },
                            [
                              _c("div", { staticClass: "dropdown d-inline" }, [
                                _vm._m(1, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                  },
                                  [
                                    _c(
                                      "h6",
                                      { staticClass: "dropdown-header" },
                                      [_vm._v("Portfolio plans")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(p.Scenarios, function (s) {
                                      return _c(
                                        "a",
                                        {
                                          key: s.Id,
                                          staticClass: "dropdown-item",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleUpdateActivePortfolioScenarioCommand(
                                                p.PortfolioId,
                                                s.Id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(s.Name))]
                                      )
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "dropdown-divider",
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "sanitizedHref",
                                            rawName: "v-sanitizedHref",
                                            value: `/#/portfolio-plans/${p.WorkspaceId}/${p.TchProjectId}`,
                                            expression:
                                              "`/#/portfolio-plans/${p.WorkspaceId}/${p.TchProjectId}`",
                                          },
                                        ],
                                        staticClass: "dropdown-item",
                                      },
                                      [_vm._v("Manage plans")]
                                    ),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  attrs: {
                                    disabled: p.ScenarioId == null,
                                    title: "Selector",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.showSelectorDialog(p)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "fa-solid fa-robot" })]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(p.RequestedProjectsCount)
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.fmtPct(p.RequestedProjectsCountShare)
                                )
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(p.AcceptedProjectsCount)
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.fmtPct(p.AcceptedProjectsCountShare))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(p.PlannedValuePoints))
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.fmtPct(p.PlannedValuePointsShare))
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(p.PlannedRevenue))
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.fmtPct(p.PlannedRevenueShare))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(p.PlannedCost))
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.fmtPct(p.PlannedCostShare))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-center align-middle" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.fmtNum(p.CostOfValuePoint)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-center align-middle" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.fmtNum(p.StrategicFit, 10)) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", {}, [
                      _c("tr", [
                        _c("td", { attrs: { colspan: "2" } }),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.rm.RequestedProjectsCount) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.rm.AcceptedProjectsCount) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.fmtNum(_vm.rm.PlannedValuePoints)) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.fmtNum(_vm.rm.PlannedRevenue)) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.fmtNum(_vm.rm.PlannedCost)) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.fmtNum(_vm.rm.CostOfValuePoint)) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }),
                      ]),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _c("thead", [
                      _c("tr", { staticClass: "table-secondary" }, [
                        _c(
                          "th",
                          {
                            staticClass: "align-middle",
                            attrs: { colspan: "2" },
                          },
                          [_vm._v("Budget allocation")]
                        ),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Allocation "),
                          _c("br"),
                          _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "align-middle text-center" }, [
                          _vm._v("Limit"),
                          _c("br"),
                          _vm._v(" (" + _vm._s(_vm.rm.CurrencyLabel) + ")"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "totalCost" },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "align-middle text-center",
                              staticStyle: { width: "60px" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.budget.TotalCostCollapsed =
                                        !_vm.budget.TotalCostCollapsed
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.budget.TotalCostCollapsed
                                        ? "fa-chevron-down"
                                        : "fa-chevron-up",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v("\n                            Total cost"),
                            _c("br"),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(_vm._s(_vm.rm.TotalCostLabel)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(_vm.budget.TotalCostCurrentValue)
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(_vm.budget.TotalCostLimit)) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.budget.TotalCostItems, function (p) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.budget.TotalCostCollapsed === false,
                                  expression:
                                    "budget.TotalCostCollapsed === false",
                                },
                              ],
                              key: p.Id,
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.fmtNum(p.CurrentValue)) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  p.Limit != null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showTotalCostLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.fmtNum(p.Limit)))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.Limit == null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-danger font-italic pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showTotalCostLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Not set")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "opex" },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "align-middle text-center",
                              staticStyle: { width: "60px" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.budget.OpexCollapsed =
                                        !_vm.budget.OpexCollapsed
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.budget.OpexCollapsed
                                        ? "fa-chevron-down"
                                        : "fa-chevron-up",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              "\n                            Opex\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(_vm.budget.OpexCurrentValue)
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(_vm.budget.OpexLimit)) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.budget.OpexItems, function (p) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.budget.OpexCollapsed === false,
                                  expression: "budget.OpexCollapsed === false",
                                },
                              ],
                              key: p.Id,
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.fmtNum(p.CurrentValue)) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  p.Limit != null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOpexLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.fmtNum(p.Limit)))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.Limit == null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-danger font-italic pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOpexLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Not set")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "capex" },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "align-middle text-center",
                              staticStyle: { width: "60px" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.budget.CapexCollapsed =
                                        !_vm.budget.CapexCollapsed
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.budget.CapexCollapsed
                                        ? "fa-chevron-down"
                                        : "fa-chevron-up",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              "\n                            Capex\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(_vm.budget.CapexCurrentValue)
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(_vm.budget.CapexLimit)) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.budget.CapexItems, function (p) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.budget.CapexCollapsed === false,
                                  expression: "budget.CapexCollapsed === false",
                                },
                              ],
                              key: p.Id,
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.fmtNum(p.CurrentValue)) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  p.Limit != null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showCapexLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.fmtNum(p.Limit)))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.Limit == null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-danger font-italic pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showCapexLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Not set")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "othex" },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "align-middle text-center",
                              staticStyle: { width: "60px" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.budget.OthexCollapsed =
                                        !_vm.budget.OthexCollapsed
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.budget.OthexCollapsed
                                        ? "fa-chevron-down"
                                        : "fa-chevron-up",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(_vm.budget.OthexCurrentValue)
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(_vm.budget.OthexLimit)) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.budget.OthexItems, function (p) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.budget.OthexCollapsed === false,
                                  expression: "budget.OthexCollapsed === false",
                                },
                              ],
                              key: p.Id,
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.fmtNum(p.CurrentValue)) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  p.Limit != null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOthexLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.fmtNum(p.Limit)))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.Limit == null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-danger font-italic pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOthexLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Not set")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "expenses" },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "align-middle text-center",
                              staticStyle: { width: "60px" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.budget.ExpensesCollapsed =
                                        !_vm.budget.ExpensesCollapsed
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.budget.ExpensesCollapsed
                                        ? "fa-chevron-down"
                                        : "fa-chevron-up",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(_vm.budget.ExpensesCurrentValue)
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.fmtNum(_vm.budget.ExpensesLimit)) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.budget.ExpensesItems, function (p) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.budget.ExpensesCollapsed === false,
                                  expression:
                                    "budget.ExpensesCollapsed === false",
                                },
                              ],
                              key: p.Id,
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.fmtNum(p.CurrentValue)) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  p.Limit != null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showExpensesLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.fmtNum(p.Limit)))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.Limit == null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-danger font-italic pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showExpensesLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Not set")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "opex-expenses" },
                      [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "align-middle text-center",
                              staticStyle: { width: "60px" },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-outline-secondary",
                                  on: {
                                    click: function ($event) {
                                      _vm.budget.OpexExpensesCollapsed =
                                        !_vm.budget.OpexExpensesCollapsed
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    class: [
                                      "fa",
                                      _vm.budget.OpexExpensesCollapsed
                                        ? "fa-chevron-down"
                                        : "fa-chevron-up",
                                    ],
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(4),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(
                                    _vm.budget.OpexExpensesCurrentValue
                                  )
                                ) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.fmtNum(_vm.budget.OpexExpensesLimit)
                                ) +
                                "\n                        "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.budget.OpexExpensesItems, function (p) {
                          return _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.budget.OpexExpensesCollapsed === false,
                                  expression:
                                    "budget.OpexExpensesCollapsed === false",
                                },
                              ],
                              key: p.Id,
                            },
                            [
                              _c("td"),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(p.Name))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.fmtNum(p.CurrentValue)) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  p.Limit != null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-primary",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOpexExpensesLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.fmtNum(p.Limit)))]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  p.Limit == null
                                    ? [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "text-danger font-italic pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showOpexExpensesLimitEditor(
                                                  p
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Not set")]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._l(_vm.resources, function (r) {
                      return _c(
                        "tbody",
                        { key: r.Id },
                        [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "align-middle text-center",
                                staticStyle: { width: "60px" },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-secondary",
                                    on: {
                                      click: function ($event) {
                                        r.IsCollapsed = !r.IsCollapsed
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: [
                                        "fa",
                                        r.IsCollapsed
                                          ? "fa-chevron-down"
                                          : "fa-chevron-up",
                                      ],
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(r.Name) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _c(
                                "span",
                                {
                                  class: [
                                    r.TargetPercent > 1
                                      ? "text-danger"
                                      : "text-dark",
                                  ],
                                },
                                [_vm._v(_vm._s(_vm.fmtPct(r.TargetPercent, 0)))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _c(
                                "span",
                                {
                                  class: [
                                    r.TargetPercent > 1
                                      ? "text-danger"
                                      : "text-dark",
                                  ],
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.fmtNum(r.TargetValue)) +
                                      " " +
                                      _vm._s(r.Unit)
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.fmtNum(r.CurrentValue)) +
                                  " " +
                                  _vm._s(r.Unit) +
                                  " "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("small", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(_vm.fmtPct(r.CurrentPercent))),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._l(r.Portfolios, function (p) {
                            return _c(
                              "tr",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: r.IsCollapsed == false,
                                    expression: "r.IsCollapsed == false",
                                  },
                                ],
                                key: p.Id,
                              },
                              [
                                _c("td"),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(p.Name))]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-center" },
                                  [
                                    p.IsLinked === true
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "dropdown" },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "text-primary",
                                                  attrs: {
                                                    "data-toggle": "dropdown",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        _vm.fmtPct(
                                                          p.TargetPercent,
                                                          0
                                                        )
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "dropdown-menu dropdown-menu-scrollable dropdown-menu-right",
                                                  attrs: { role: "menu" },
                                                },
                                                _vm._l(41, function (n) {
                                                  return _c(
                                                    "a",
                                                    {
                                                      key: n,
                                                      staticClass:
                                                        "dropdown-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.handleSetPortfolioResourceAllocationCommand(
                                                            p.Id,
                                                            r.Id,
                                                            (n - 1) / 20
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s((n - 1) * 5) +
                                                          "%\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                }),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-center" },
                                  [
                                    p.IsLinked === true
                                      ? [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.fmtNum(p.TargetValue)
                                              ) +
                                              " " +
                                              _vm._s(r.Unit) +
                                              "\n                            "
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.fmtNum(p.CurrentValue))
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      _vm._s(_vm.fmtPct(p.CurrentPercent))
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-5" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._l(_vm.rm.Usage, function (r) {
                      return _c(
                        "tbody",
                        { key: r.Id },
                        [
                          _c("tr", [
                            _c("td", [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/enterprise/resource-capacity/${_vm.workspaceId}/${_vm.strategyId}/${r.Id}`,
                                      expression:
                                        "`/#/enterprise/resource-capacity/${workspaceId}/${strategyId}/${r.Id}`",
                                    },
                                  ],
                                  staticClass: "text-primary",
                                },
                                [_vm._v(_vm._s(r.Name) + " " + _vm._s(r.Unit))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { attrs: { colspan: "12" } }),
                          ]),
                          _vm._v(" "),
                          _vm._l(r.Years, function (y) {
                            return _c(
                              "tr",
                              { key: y.Year },
                              [
                                _c(
                                  "td",
                                  { staticClass: "align-middle text-center" },
                                  [_vm._v(_vm._s(y.Year))]
                                ),
                                _vm._v(" "),
                                _vm._l(12, function (i) {
                                  return _c(
                                    "td",
                                    {
                                      key: i,
                                      staticClass: "align-middle text-center",
                                      class: {
                                        "table-danger":
                                          y.Capacity[i - 1] -
                                            y.Allocation[i - 1] <
                                          0,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.fmtNum(
                                              y.Capacity[i - 1] -
                                                y.Allocation[i - 1]
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          }),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", { staticClass: "align-middle text-center" }, [
      _vm._v("Strategic fit "),
      _c("br"),
      _vm._v(" (0-100)"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-outline-secondary",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "fa-solid fa-ellipsis" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", [
      _vm._v("\n                            Other"),
      _c("br"),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v("Non-Opex, Non-COGS"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", [
      _vm._v("\n                            Expenses (All)"),
      _c("br"),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [_vm._v("Cogs, Opex, Other")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("th", [
      _vm._v("\n                            Expenses (Opex)"),
      _c("br"),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v("Opex Expense Accounts"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", { staticClass: "table-secondary" }, [
        _c("th", { staticClass: "align-middle", attrs: { colspan: "2" } }, [
          _vm._v("Resource allocation"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle text-center" }, [
          _vm._v(
            "\n                            Target\n                            "
          ),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted" }, [
            _vm._v("% of available"),
          ]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle text-center" }, [
          _vm._v("\n                            Capacity "),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted" }, [_vm._v("Target based")]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle text-center" }, [
          _vm._v("Allocation"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", { staticClass: "table-secondary" }, [
        _c("th", [_vm._v("Capacity minus allocated")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Jan")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Feb")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Mar")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Apr")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("May")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Jun")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Jul")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Aug")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Sep")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Oct")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Nov")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-center" }, [_vm._v("Dec")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }